const removerPontosETracos = (value) => {
  if (!value) return '';
  return value.normalize('NFD').replace(/[^a-zA-Z0-9]/g, '');
};

export default removerPontosETracos;
